// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__36trZ","left":"InfoRow_left__2u7Wq"};